
/**
 * 校验站点信息
 * 返回信息
 */
import { Site } from '@/common/const'

/**
 * 国家及货币单位
 */
enum STATION {
  /**
   * 日本站
   */
  JA = 'ja',
  /**
   * 韩国站
   */
  KO = 'ko',
  /**
   * 英国站
   */
  EN = 'en',
}
/**
 * 把stationCode 转成站点
 *  JapanStation KoreaStation UkStation -> ja ko en
 */
export const stationCodeToSite = (stationCode:Site) => {
  if (stationCode === Site.JA) return STATION.JA
  if (stationCode === Site.KO) return STATION.KO
  return STATION.EN
}
